import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { formatDateString } from "./fulfillment-group-csv-utils";

/** The calendar day in the merchant time zone, the day the fulfill-by picker shows. */
export function formatFulfillByDate(
  fulfillBy: Date | null | undefined,
  timeZone: string,
): string {
  if (!fulfillBy) {
    return "";
  }
  try {
    return fulfillBy.toLocaleDateString("default", {
      month: "short",
      day: "numeric",
      year: "numeric",
      timeZone,
    });
  } catch {
    // An unknown time zone name throws a RangeError.
    return formatDateString(fulfillBy.toISOString());
  }
}

export function getMarketplaceFulfillByCsvColumn(
  timeZone: string,
): FulfillmentGroupCsvColumn<FulfillmentGroupData> {
  return {
    header: "Fulfill by date",
    cell: (row) => formatFulfillByDate(row.fulfillBy, timeZone),
  };
}
